<div class="kp-stats-info-grid">
    <slot/>
</div>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";

    .kp-stats-info-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
        gap: @spacing-ml;
        width: 100%;
    }
</style>